import React from "react";
import ToastNotification from './components/ToastNotification';
import { toastsState } from "./state/atoms";
import { useRecoilValue } from 'recoil';

export default function Toasts() {
  const toasts:any[] = useRecoilValue(toastsState);
  return (
    <div
      aria-live="assertive"
      className="mx-auto fixed inset-0 flex items-start px-4 py-6 pointer-events-none sm:p-6 sm:items-end"
    >
      <div className="w-full flex flex-col items-center space-y-4 sm:items-start">
        {toasts.map((toast: any, i: number) => {
          return (
            <ToastNotification
              key={"toast-" + i}
              index={i}
              type={toast.type}
              title={toast.title}
              description={toast.description}
              timeout={toast.timeout}
            />
          );
        })}
      </div>
    </div>
  );
}
